module.exports = __webpack_public_path__ + "media/icons/warning-icon-triangle-81bfe0f1.svg";